<template>
    <div style="width: 100%">
        <el-row :gutter="20" class="ordinary">
            <el-col
                    class="col"
                    style="margin: 0 !important;"
                    :xs="24"
                    :sm="24"
                    :md="8"
                    :lg="8"
                    :xl="8"
                    v-for="(item2, index2) in hxContentList"
                    :key="index2"
            >
                <div class="grid-content">
                    <div
                            v-if="item2.title"
                            class="title"

                    >
                        {{ item2.title }}
                    </div>

                    <div
                            v-if="item2.time"
                            class="time"
                    >
                        {{ item2.time }}
                    </div>

                    <div
                            class="ql-editor firstLine contDiv"
                            v-if="item2.content"
                            v-html="item2.content"
                    ></div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script>
    export default {
        name: "ordinary-list-index",
        props: {
            hxContentList: Array
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        width: 70%;
    }

    .ordinary {
        display: flex;
        justify-content: left;
        /*overflow-y: hidden;*/
        flex-wrap: wrap;
    }

    @media screen and (min-width: 1400px) {
        .container {
            width: 70%;
        }
        .type-area {
            width: 80%;
            margin: 0 auto;
        }

        .firstLine {
            font-size: 14px;
        }

        .grid-content {
            padding: 0 20px;
        }
    }

    @media screen and (min-width: 1200px) {
        /*.row{*/
        /*    margin: 0 25px !important;*/
        /*}*/

        .grid-content {
            padding: 0 20px;
        }
    }

    @media screen and (max-width: 1200px) {
        .container {
            width: 70%;
        }
        .type-area {
            width: 100%;
            margin: 0 auto;
        }

        /*.row{*/
        /*    margin: 0 25px !important;*/
        /*}*/

        .firstLine {
            font-size: 14px;
        }

        .grid-content {
            padding: 0 20px;
        }
    }

    @media screen and (max-width: 870px) {
        .container {
            width: 90%;
        }
        .type-area {
            width: 100%;
            margin: 0 auto;
        }

        /*.row{*/
        /*    margin: 0 25px !important;*/
        /*}*/

        .firstLine {
            font-size: 14px;
        }

        .col {
            margin-top: 20px;
        }

        .grid-content {
            padding: 0;
        }
    }

    @media screen and (max-width: 570px) {
        .container {
            width: 90%;
        }
        .type-area {
            width: 100%;
            margin: 0 auto;
        }

        /*.row{*/
        /*    margin: 0 25px !important;*/
        /*}*/

        .firstLine {
            font-size: 13px;
        }

        .col {
            margin-top: 20px;
        }

        .grid-content {
            padding: 0;
        }
    }

    .title {
        text-align: left;
        font-size: 18px;
        font-weight: bold;
        color: #0094ff;
    }

    .time {
        display: block;
        font-size: 12px;
        color: #9e9e9e;
        height: 30px;
        line-height: 30px;
    }

    .firstLine {
        color: #999;
        padding: 0;
        height: 82px;
        overflow: auto;
        margin-bottom: 20px;
    }
</style>
